/* eslint-disable react-hooks/exhaustive-deps */
import { Button, Divider } from "@mui/material";
import { CustomerModel, Location } from "../../Utils/Models";
import { Add, Remove } from "@mui/icons-material";
import { Vocabulary } from "../../Utils/Vocabulary";
import { useEffect, useState } from "react";
import Address from "./Address";
import Contact from "./Contact";

type AddressesProp = {
  customer: CustomerModel;
  handleChangeCustomer: (product: CustomerModel) => void;
};

const Addresses = (prop: AddressesProp) => {
  const { customer, handleChangeCustomer } = prop;
  const [lines, setLine] = useState(1);

  useEffect(() => {
    if (customer.locations.length > 0) {
      setLine(customer.locations.length);
    }
  }, []);

  useEffect(() => {
    if (!customer.isLegalPerson) {
      customer.locations = [new Location()];
      setLine(1);
    }
  }, [customer.isLegalPerson]);
  return (
    <div>
      {Array.from({ length: lines }).map((_, index) => (
        // eslint-disable-next-line react/no-array-index-key
        <div style={{ marginTop: 20 }} key={index}>
          {customer.isLegalPerson && (
            <Button
              variant="contained"
              startIcon={<Remove />}
              onClick={() => removeAtIndex(index)}
            >
              {Vocabulary.remove}
            </Button>
          )}
          <Address
            customer={customer}
            index={index}
            handleChangeCustomer={handleChangeCustomer}
          />
          <div style={{ marginTop: 20 }}>
            <span>{Vocabulary.contactPerson}</span>
            <Contact
              customer={customer}
              index={index}
              handleChangeCustomer={handleChangeCustomer}
            />
          </div>
          {index < lines - 1 && <Divider style={{ marginTop: 10 }} />}
        </div>
      ))}
      {customer.isLegalPerson && (
        <Button
          variant="contained"
          startIcon={<Add />}
          onClick={() => {
            setLine((prev) => prev + 1);
            customer.locations.push(new Location());
          }}
          style={{ marginTop: 20 }}
        >
          {Vocabulary.add}
        </Button>
      )}
    </div>
  );

  function removeAtIndex(indexToRemove: number) {
    setLine((prev) => prev - 1);
  }
};

export default Addresses;
